// Types and constants for the Redeem Rules module.
// Field names and the auto-redeem rule-builder semantics are preserved verbatim
// from the legacy rapido-dashboard implementation to keep the rapido-redeem API
// contract intact.

export interface RuleBuilderRow {
  variable: string;
  operator: string;
  value: any;
  maxValue?: any;
}

// A generated auto-redeem rule as stored by rapido-redeem.
export interface GeneratedRule {
  variable: string;
  condition: string;
  min?: number;
  max?: number;
}

export interface RedeemRule {
  _id?: string;
  cities: string[];
  shift: string[];
  modeId?: string;
  weekDays: string[];
  transactionPeriod: string;
  transactionCount: number;
  blockRedeem?: boolean;
  minTransactionAmount: number;
  firstRedeemMinAmount?: number;
  startDate: string;
  tnc: any;
  active?: boolean;
  extraCharge?: number;
  createdOn?: number;
  multiAutoRedeemRules?: { [setIndex: string]: GeneratedRule[] };
  automationRules?: GeneratedRule[];
}

export const WEEK_DAYS = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

export const TRANSACTION_PERIODS = ['daily', 'weekly', 'monthly'];

export const VARIABLE_LIST = [
  { name: 'Loss per Order(LPO)', value: 'lossPerOrder' },
  { name: 'Order Burn Per Order', value: 'obPerOrder' },
  { name: 'Burn Per Order(BPO)', value: 'burnPerOrder' },
  { name: 'Redeem Amount(RA)', value: 'redeemAmount' },
  { name: 'Discount per Order(DPO)', value: 'discountPerOrder' },
  { name: 'Is First Redeem?', value: 'isFirstRedeem' },
  { name: 'Loss per Km(LPK)', value: 'lossPerKm' },
  { name: 'Burn Per Km(BPK)', value: 'burnPerKm' },
  { name: 'Discount per Km(DPK)', value: 'discountPerKm' },
  { name: 'Number of orders', value: 'numberOfOrders' },
  { name: 'Total Kilometers', value: 'totalKm' },
  { name: 'Order Loss Per Km', value: 'olPerKm' },
  { name: 'Order Loss Per Order', value: 'olPerOrder' },
  { name: 'Order Burn Per Km', value: 'obPerKm' },
  { name: 'Incentive Loss', value: 'incentiveLoss' },
  { name: 'Incentive Loss Per KM', value: 'incentiveLossPerKm' },
  { name: 'Incentive Loss Per Order', value: 'incentiveLossPerOrder' },
  { name: 'Incentive orders average distance', value: 'incentiveOrderAverageDistance' },
  { name: 'Discount orders average distance', value: 'discountedOrderAverageDistance' },
  { name: '% distance frauds', value: 'percentageDistanceFraud' },
  { name: '% pickup location fraud', value: 'percentageDifferentSetPickupLocationFraud' },
  { name: '% EFOR orders', value: 'percentageOfEforOrders' },
  { name: '% EFOR earnings of Redeem Amount', value: 'percentageOfEforEarningsOfRedeemAmount' }
];

export const OPERATOR_LIST = [
  { name: 'Greater than', value: '>' },
  { name: 'Less than', value: '<' },
  { name: 'Between', value: 'between' },
  { name: 'Equals', value: '==' }
];

export const BOOLEAN_VALUES = [
  { name: 'True', value: 'true' },
  { name: 'False', value: 'false' }
];
